export default "__VITE_ASSET__DP0i73CZ__"